import { render, staticRenderFns } from "./medal_detailList.vue?vue&type=template&id=08f84358&scoped=true"
import script from "./medal_detailList.vue?vue&type=script&lang=js"
export * from "./medal_detailList.vue?vue&type=script&lang=js"
import style0 from "./medal_detailList.vue?vue&type=style&index=0&id=08f84358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f84358",
  null
  
)

export default component.exports